// This file was once generated when you created this area
// but you can edit it freely

import { transformRoutes } from '@backoffice-frontend/common'

// Strips the leading slash so a route can be used as a relative <Route path>.
export const relative = (route: string) => route.replace(/^\//, '')

// Preferred name for the base route constant — the ROUTEOWNERS_SENTRY generator
// tries this name first. Any other name also works (the generator falls back to
// the first path constant in the file), but `baseRoute` is the convention.
const baseRoute = '/virtual-testing'

export const BaseVirtualTestingAreaRoutes = {
  route: baseRoute,
  Analyses: {
    route: '/analyses',
    MeasurementDetails: {
      route: '/measurements/:analysisUuid',
    },
  },
  Scenarios: {
    route: '/scenarios',
  },
}

export const VirtualTestingAreaRoutes = transformRoutes(
  BaseVirtualTestingAreaRoutes,
)
